<template>
  <div class="stage-wrapper" ref="triggerRef">
    <div ref="pinRef">
      <div class="stage" ref="pinRef">
        <div class="sequence-wrapper">
          <div class="stage__image_wrapper" ref="stageImageRef">
            <img class="stage__image" ref="imgRef" :src="bindedSrc" />
            <img class="stage__image2" ref="imgRef2" :src="secondImg" />
            <img class="stage__image3" ref="imgRef3" :src="thirdImg" />
          </div>
          <div class="title-wrap" ref="titleRef">
            <div class="title-section" ref="titleSectionRef" v-for="(item, i) in titles" :key="i">
              <div class="main-title">
                {{ item.title }}
                <!-- Introducing our new Eco-package -->
              </div>
              <div class="sub-title">
                {{ item.subTitle }}
                <!-- A TV box specifically designed to be creatively upcycled instead of merely recycled -->
              </div>
            </div>
          </div>
        </div>
        <div class="stage-bottom" :class="{ active: arrowActive }">
          <slot name="down-arrow"></slot>
        </div>
        <!-- <slot name="other">test</slot> -->
      </div>
      <slot name="category-list"></slot>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { TimelineMax, TweenMax, Linear } from "gsap";
import * as ScrollMagic from "scrollmagic";
// import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";
export default {
  props: {
    onLoadComplete: {
      type: Function,
      default: () => {},
    },
  },
  created() {
    const loadImgArr = new Array();
    let loadCompleteCount = 0;
    for (const imgSrc of this.images) {
      const img = new Image();

      const convertImg = {};
      this.convertedImages.push(convertImg);
      img.src = imgSrc;
      loadImgArr.push(img);

      img.onload = () => {
        loadCompleteCount++;
        convertImg.src = this.getBase64Image(img);

        if (this.images.length === loadCompleteCount) {
          this.onLoadComplete(true);
          this.init();
        }
      };
    }
    this.titles = [
      {
        title: this.$t("LandingPage.sequence1_1"),
        subTitle: this.$t("LandingPage.sequence1_2"),
      },
      {
        title: this.$t("LandingPage.sequence2_1"),
        subTitle: this.$t("LandingPage.sequence2_2"),
      },
      {
        title: this.$t("LandingPage.sequence3_1"),
        subTitle: this.$t("LandingPage.sequence3_2"),
      },
      {
        title: this.$t("LandingPage.sequence4_1"),
        subTitle: this.$t("LandingPage.sequence4_2"),
      },
    ];
  },
  data() {
    return {
      images: Array(61)
        .fill("")
        .map((v, i) =>
          require(`../../assets/landing_page/landing${
            i < 10 ? `0${i}` : i
          }.jpg`)
        ),
      bindedSrc: "",
      titles: [{}, {}, {}],
      arrowActive: false,
      convertedImages: [],
      secondImg: require("../../assets/landing_cathouse.jpg"),
      thirdImg: require("../../assets/landing_deskshelf.jpg"),
    };
  },
  methods: {
    init() {
      // const imgRef = this.$refs.imgRef;
      // console.log("clientHeight", window.scrollY, this.$refs.imgRef.clientTop);
      const triggerRef = this.$refs.triggerRef;
      const pinRef = this.$refs.pinRef;
      // const titleRef = this.$refs.titleRef;
      const height = window.innerHeight;

      // const heightGap = window.outerHeight - window.innerHeight;

      // console.log(window.outerHeight, window.innerHeight);

      // const width = window.innerWidth;
      // const triggerTop = triggerRef.getBoundingClientRect().top;
      // const sectionTop = imgRef.getBoundingClientRect().top - triggerTop;
      // const sectionHeight = imgRef.offsetHeight;

      const controller = new ScrollMagic.Controller();

      new ScrollMagic.Scene({
        triggerElement: triggerRef,
        triggerHook: 0,
        duration: 5 * height,
        offset: 0,
        // + (width > 1024 ? -150 : width > 720 ? -125 : -170)
      })
        .setPin(pinRef, { pushFollowers: false })
        .on("enter", () => {
          this.arrowActive = true;
        })
        .on("leave", () => {
          this.arrowActive = false;
        })
        // .setTween(tween)

        // .addIndicators({ name: "1" }) // add indicators (requires plugin)
        .addTo(controller);

      const obj = { curImg: 0 };
      const tween = TweenMax.to(obj, 1, {
        curImg: this.images.length - 1, // animate propery curImg to number of images
        roundProps: "curImg", // only integers so it can be used as an array index
        repeat: 0, // repeat 3 times
        immediateRender: true, // load first image automatically
        ease: Linear.easeNone, // show every image the same ammount of time
        onUpdate: () => {
          this.bindedSrc = this.convertedImages[obj.curImg].src; // set the image source
        },
      });
      new ScrollMagic.Scene({
        triggerElement: this.$refs.triggerRef,
        triggerHook: 0.5,
        duration: 2 * height,
        offset: 0.5 * height,
      })
        .setTween(tween)
        // .addIndicators({ name: "2" })
        .addTo(controller);

      this.titles.forEach((v, i) => {
        const titleWrapEl = this.$refs.titleSectionRef[i];
        if (i === 0) {
          const tl = new TimelineMax();
          // tl.to(titleWrapEl, 0, { , opacity: 0, display: "none" });

          tl.to(titleWrapEl, 0, {
            yPercent: -50,
            opacity: 1,
            display: "block",
          });

          if (i != this.titles.length - 1) {
            tl.to(titleWrapEl, 1, { opacity: 0, display: "none" });
          }
          new ScrollMagic.Scene({
            triggerElement: this.$refs.triggerRef,
            triggerHook: 0.5,
            duration: 0.2 * height,
            offset: 2 * height,
          })
            .setTween(tl)
            // .addIndicators({ name: i-1 })
            .addTo(controller);
        }
        // else{
        //   const tl = new TimelineMax();
        //   // tl.to(titleWrapEl, 0, { opacity: 0, display: "none" });
        // tl.to(titleWrapEl, 0.1, { opacity: 0, display: "block" });
        // tl.to(titleWrapEl, 0.1, { yPercent: 0, opacity: 0 });
        // tl.to(titleWrapEl, 1, { display:"block",opacity: 1, yPercent: -50 });
        // if (i != this.titles.length - 1) {
        //   tl.to(titleWrapEl, 1, { opacity: 0, display: "none" }
        //   );
        // if(i===1)
        // {
        //   tl.to(this.$refs.imgRef,1,{opacity:0});
        //   tl.to(this.$refs.imgRef3,1,{opacity:0});
        //   tl.to(this.$refs.imgRef2, 0.1, { yPercent: 10, opacity: 0 });
        //   tl.to(this.$refs.imgRef2, 1, { opacity: 1, yPercent: 0 });
        //   // tl.to(this.$refs.imgRef2,1,{opacity:1});
        // }
        // if(i===2)
        // {
        //   tl.to(this.$refs.imgRef,1,{opacity:0});
        //   tl.to(this.$refs.imgRef2,1,{opacity:0});
        //   tl.to(this.$refs.imgRef3, 0.1, { yPercent: 10, opacity: 0 });
        //   tl.to(this.$refs.imgRef3, 1, { opacity: 1, yPercent: 0 });
        //   // tl.to(this.$refs.imgRef3,1,{opacity:1});
        // }
        // }
        // new ScrollMagic.Scene({
        //   triggerElement: this.$refs.triggerRef,
        //   triggerHook: 0.5,
        //   duration: height,
        //   offset: 1.2 * height + i * height
        // })
        //   .setTween(tl)
        //   .addIndicators({ name: i })
        //   .addTo(controller);
        // }
      });

      const timeline = new TimelineMax();

      timeline.to(this.$refs.imgRef, 0.1, { opacity: 0 });
      timeline.to(this.$refs.imgRef2, 0.2, { yPercent: 6, opacity: 0 });

      timeline.to(this.$refs.imgRef2, 0.5, { opacity: 1, yPercent: 0 });

      new ScrollMagic.Scene({
        triggerElement: this.$refs.triggerRef,
        triggerHook: 0.5,
        duration: 0.4 * height,
        offset: 1.2 * height + 2 * height,
      })
        .setTween(timeline)
        // .addIndicators({ name: "image2" })
        .addTo(controller);

      const timeline2 = new TimelineMax();

      timeline2.to(this.$refs.imgRef2, 0.1, { opacity: 0 });
      timeline2.to(this.$refs.imgRef3, 0.2, { yPercent: 6, opacity: 0 });

      timeline2.to(this.$refs.imgRef3, 0.5, { opacity: 1, yPercent: 0 });

      new ScrollMagic.Scene({
        triggerElement: this.$refs.triggerRef,
        triggerHook: 0.5,
        duration: 0.4 * height,
        offset: 1.2 * height + 3 * height,
      })
        .setTween(timeline2)
        // .addIndicators({ name: "image3" })
        .addTo(controller);

      const timelinet1 = new TimelineMax();

      timelinet1.to(this.$refs.titleSectionRef[0], 0.1, {
        opacity: 0,
        display: "none",
      });
      timelinet1.to(this.$refs.titleSectionRef[1], 0.2, {
        display: "none",
        opacity: 0,
      });
      timelinet1.to(this.$refs.titleSectionRef[1], 0.5, {
        display: "block",
        opacity: 1,
        yPercent: -50,
      });
      timelinet1.to(this.$refs.titleSectionRef[1], 1, { opacity: 1 });

      new ScrollMagic.Scene({
        triggerElement: this.$refs.triggersRef,
        triggerHook: 0.5,
        duration: height,
        offset: 1.2 * height + 0.5 * height,
      })
        .setTween(timelinet1)
        // .addIndicators({ name: "text1" })
        .addTo(controller);

      const timelinet2 = new TimelineMax();

      timelinet2.to(this.$refs.titleSectionRef[1], 0.1, {
        opacity: 0,
        display: "none",
      });
      timelinet2.to(this.$refs.titleSectionRef[2], 0.2, {
        display: "none",
        opacity: 0,
      });
      timelinet2.to(this.$refs.titleSectionRef[2], 0.5, {
        display: "block",
        opacity: 1,
        yPercent: -50,
      });
      timelinet2.to(this.$refs.titleSectionRef[2], 1, { opacity: 1 });

      new ScrollMagic.Scene({
        triggerElement: this.$refs.triggersRef,
        triggerHook: 0.5,
        duration: height,
        offset: 1.2 * height + 1.5 * height,
      })
        .setTween(timelinet2)
        // .addIndicators({ name: "text2" })
        .addTo(controller);

      const timelinet3 = new TimelineMax();

      timelinet3.to(this.$refs.titleSectionRef[2], 0.1, {
        opacity: 0,
        display: "none",
      });
      timelinet3.to(this.$refs.titleSectionRef[3], 0.2, {
        display: "none",
        opacity: 0,
      });
      timelinet3.to(this.$refs.titleSectionRef[3], 0.5, {
        display: "block",
        opacity: 1,
        yPercent: -50,
      });
      timelinet3.to(this.$refs.titleSectionRef[3], 1, { opacity: 1 });

      new ScrollMagic.Scene({
        triggerElement: this.$refs.triggersRef,
        triggerHook: 0.5,
        duration: height,
        offset: 1.2 * height + 2.5 * height,
      })
        .setTween(timelinet3)
        // .addIndicators({ name: "text3" })
        .addTo(controller);
      ////////////////////////////////////////////////////////////////////////////////////////////////////////
    },

    getBase64Image(img) {
      // Create an empty canvas element
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      // Copy the image contents to the canvas
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL;
    },
  },
  mounted() {
    // this.bindedSrc = this.images[0];

    this.$nextTick(() => {
      // const init = () => {
      //   this.init();
      // };
      // this.$refs.imgRef.onload = init.bind(this);
    });
  },
};
</script>

<style scoped>
.stage-wrapper {
  /* position: relative; */
  /* height: 100%; */
  min-height: calc(700vh);
  /* height: auto; */
  /* max-width: 1200px; */
  margin-left: auto;
  margin-right: auto;
}
.stage {
  /* top: 30% !important; */
  display: flex;
  height: 100vh;
  position: relative;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.sequence-wrapper {
  /* position: absolute; */
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  width: 100%;
}
.stage__image_wrapper {
  width: 60%;
  display: flex;
  align-items: center;
  position: relative;
}
.stage__image {
  width: 100%;
  max-height: 100vh;
  object-fit: contain;
}
.stage__image2 {
  width: 100%;
  max-height: 100vh;
  object-fit: contain;
  opacity: 0;
  position: absolute;
}
.stage__image3 {
  width: 100%;
  max-height: 100vh;
  object-fit: contain;
  opacity: 0;
  position: absolute;
}
.title-wrap {
  /* position: relative; */
  /* top: 50%; */
  background-color: black;
  width: 40%;
  text-align: left;
  margin-left: 29px;
  font-weight: bold;
}
.title-section {
  position: relative;
  display: none;
  top: 50%;
  color: white;
  font-size: 2.9rem;
  /* transform: translateY(-50%); */
}

.title-section .sub-title {
  color: #aaaaaa;
}
.stage-bottom {
  position: absolute;
  /* bottom: 10%; */
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 1023px) {
  .scrollmagic-pin-spacer {
    vertical-align: top;
  }
  /* .stage-wrapper {
    position: relative;
    top: -200px;
  } */
}
/* .sticky {
  /* position: fixed; */
/* top: 0;
  position: relative; */

@media screen and (max-width: 767px) {
  /* .stage-wrapper {
    min-height: calc(745vh);
  } */
}

.stage {
  flex-direction: column;
  justify-content: center;
  position: relative;
  /* transform: translateY(-25%); */
  height: 100vh;
  /* max-height: 100vh; */
}
.stage-wrapper {
  min-height: calc(600vh);
}
.stage__image_wrapper {
  width: 100%;
}
.sequence-wrapper {
  position: absolute;
  top: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* position: relative; */
}

.title-wrap {
  width: 58.8vw;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  /* height: 200px; */
  height: 100px;
  margin-left: 70px;
}
.title-section {
  height: 100px;
}
.main-title {
  font-size: 1.83rem;
}
.sub-title {
  font-size: 1rem;
  margin-top: 15px;
}
.main-title,
.sub-title {
  text-align: left;
}
.stage__image {
  width: 90%;
  margin: auto;
}
.stage__image2 {
  width: 90%;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  position: absolute;
}
.stage__image3 {
  width: 90%;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  position: absolute;
}
.stage-bottom.active {
  /* position: relative;
    width: 100%;
    margin-top: auto;
    height: */
  position: fixed;
  bottom: 0;

  /* bottom: unset; */
  /* top: calc(-webkit-fill-available + 50%); */
  /* top: 0; */

  /* top: -webkit-fill-available; */
}
.stage-bottom.leave {
  position: absolute;
  /* bottom: 10%; */
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.title-section {
  transform: translateY(-30px);
}
.stage__image {
  /* transform: translateY(-30px); */
}

@media screen and (min-width: 768px), screen and (orientation: landscape) {
  .stage-wrapper {
    /* position: relative; */
    /* height: 100%; */
    min-height: calc(700vh);
    /* height: auto; */
    /* max-width: 1200px; */
    margin-left: auto;
    margin-right: auto;
  }
  .stage {
    /* top: 30% !important; */
    display: flex;
    height: 100vh;
    position: relative;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  .sequence-wrapper {
    /* position: absolute; */
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    width: 100%;
    flex-direction: row;
    position: static;
    align-items: center;
  }
  .stage__image_wrapper {
    width: 40%;
    display: flex;
    align-items: center;
    position: relative;
  }
  .stage__image {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
  }
  .stage__image2 {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
    opacity: 0;
    position: absolute;
  }
  .stage__image3 {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
    opacity: 0;
    position: absolute;
  }

  .title-wrap {
    /* position: relative; */
    /* top: 50%; */
    background-color: black;
    width: 40%;
    text-align: left;
    margin-left: 29px;
    font-weight: bold;
    height: 340px;
    max-height: 80vh;
  }
  .title-section {
    position: relative;
    display: none;
    top: 50%;
    color: white;

    font-size: 2.9rem;
    /* transform: translateY(-50%); */
    /* height: 320px; */
  }
  .title-section .sub-title {
    color: #aaaaaa;
  }
  .stage-bottom {
    position: absolute;
    /* bottom: 10%; */
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (min-width: 768px) {
  .stage__image_wrapper {
    width: 60%;
    display: flex;
    align-items: center;
    position: relative;
  }
  .title-wrap {
    margin-left: 29px;
    margin-right: 0;
  }
  .main-title {
    font-size: 46px;
  }
  .sub-title {
    font-size: 24px;
    margin-top: 38px;
  }
  .title-section {
    height: 320px;
    overflow-y: visible;
    margin-right: 20px;
  }
  .title-wrap {
    margin-left: 0px;
  }
}
</style>
